export default __webpack_public_path__ + "static/media/imovelMobile.044b3d48.png";